import React from 'react';
import { Dialog } from '@material-ui/core';
import { themeColor } from '../../../mui-theme';

export default function EmeraldDialog(props) {
  return (
    <Dialog
      {...props}
      BackdropProps={{
        style: {
          backgroundColor: themeColor.modalBackgroundColor,
          opacity: '0.4',
        },
      }}
    >
      {props.children}
    </Dialog>
  );
}
